import createModalClick from '../components/createModalClick';
import { $ } from '../util/DOM';

const ModalView = (p) => {
  const html = $('.modal__click', p);

  const modal = createModalClick(html[0].innerHTML, true);

  return modal;
};

const initModalClick = () => {
  $('.modal-click__container').forEach((container) => {
    const item = $('.modal-click__item', container);
    item.forEach((p) => {
      p.addEventListener('click', (e) => {
        // eslint-disable-next-line no-param-reassign
        p.modal = ModalView(p, () => {
          item.modal.open();
        });

        e.preventDefault();
        p.modal.open();
      });
    });
  });
};

export default initModalClick;
